// extracted by mini-css-extract-plugin
module.exports = {"lazyLoadImage":"Image_lazyLoadImage__2T--x","employeeIcon":"Image_employeeIcon__EAYpQ"};